import { Box, Skeleton } from '@mui/material';
import styled from '@mui/system/styled';

const CardProfileWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    background: theme.palette.dashboard.main,
    padding: '24px',
    borderRadius: '24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
}));

const ProfileInfoContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
});

const ProfileDetailsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    flex: 1,
});

const BadgeContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 24,
    marginRight: 'auto',
    gap: '12px',
    flexWrap: 'wrap',
});

const ProfileSkeleton = () => {
    return (
        <CardProfileWrapper>
            <ProfileInfoContainer>
                {/* Avatar skeleton */}
                <Skeleton
                    variant="circular"
                    width={48}
                    height={48}
                    sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                />

                <ProfileDetailsContainer>
                    {/* Name skeleton */}
                    <Skeleton
                        variant="text"
                        width={200}
                        height={32}
                        sx={{
                            fontSize: '24px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)'
                        }}
                    />

                    <BadgeContainer>
                        {/* Badge skeletons - 5 badges like in the original */}
                        {Array.from({ length: 5 }).map((_, index) => (
                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Skeleton
                                    variant="circular"
                                    width={14}
                                    height={14}
                                    sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={60}
                                    height={30}
                                    sx={{
                                        borderRadius: '16px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                    }}
                                />
                            </Box>
                        ))}
                    </BadgeContainer>

                    {/* Action button skeleton */}
                    <Skeleton
                        variant="circular"
                        width={48}
                        height={48}
                        sx={{
                            backgroundColor: 'rgba(84, 71, 222, 0.3)',
                            marginLeft: 'auto'
                        }}
                    />
                </ProfileDetailsContainer>
            </ProfileInfoContainer>
        </CardProfileWrapper>
    );
};

export default ProfileSkeleton;
